<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">
      <div class="content-bottom-padded">
        <el-alert type="info" title="操作说明" show-icon >
          <div> 怡康店铺类型设置 </div>
        </el-alert>
      </div>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" icon="plus" @click="dialogOpen()">添加店铺类型</el-button>
        </el-col>
      </el-row>
      <el-table :data="list"  v-loading="loading">
        <el-table-column prop="shop_type_name" label="店铺类型名称"></el-table-column>
        <el-table-column prop="shop_type_comment" label="店铺类型描述"></el-table-column>
        <el-table-column prop="sort" label="排序"></el-table-column>
        <el-table-column prop="status" label="是否启用" >
          <template slot-scope="scope">
            <el-tag type="warning" v-if="scope.row.status == '0'" >启用</el-tag>
            <el-tag type="info" v-else >禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <div class="operating-icons">
              <router-link class="iconfont icon-edit1" :to="{ path: matchHidePage('editor'), query: { shop_type_id: scope.row.shop_type_id}}"></router-link>
             <!-- <i class="mark iconfont icon-trash-alt1" @click="deleteShoptypeAction(scope.$index, scope.row)"></i>-->
            </div>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    import { saveDistributor, getDistributorList, getWxaDristributorCodeStream, setDefaultDistributor } from '../../../api/marketing'
    import shopDecoration from '@/components/function/shopDecoration'
    import pcDecoration from '@/view/pc/homePage/default'
    import { getShopTypes,delShopType } from '../../../api/marketing'

    export default {
        data () {
            return {
                list: [],
                loading: false,
            }
        },
        components: { },
        computed: {
        },
        methods: {
            getList () {
                this.loading = true
                getShopTypes(this.params).then(response => {
                    if (response.data.data.list) {
                      console.log(response.data.data.list);
                        this.list = response.data.data.list
                        this.total_count = response.data.data.total_count

                    }
                    this.loading = false
                })
            },
            deleteShoptypeAction (index, row) {
                this.$confirm('此操作将删除店铺类型, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    delShopType({shop_type_id:row.shop_type_id}).then(response => {
                        this.list.splice(index, 1)
                        this.$message({
                            message: '删除成功',
                            type: 'success',
                            duration: 5 * 1000
                        })
                    })
                }).catch(() => {
                    console.log(row)
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            dialogOpen(){
                this.$router.push({path: this.matchHidePage('editor')})
            },

        },
        mounted () {
            this.getList()
        }
    }
</script>



// WEBPACK FOOTER //
// list.vue?15bf9336